import { AppShellLoginState } from '@westwing/appshell_types';
import { useEffect } from 'react';
import { OverlayOpenOptions } from 'Types/types';
import { useAppshellMeta, useLoginState } from 'AppShell/hooks';
import { hasParam } from 'SharedHelpers/url';

export const useShouldShowClubSignupOverlay = (
    handleOverlayOpen: (openOptions: OverlayOpenOptions) => void,
    isOpen: boolean,
    keepForcedClose: boolean,
    redirectUrl?: string
): boolean => {
    const loginState = useLoginState();
    const { isLoggedIn, isRegistered } = loginState as AppShellLoginState;
    const { isApp } = useAppshellMeta();
    const hasForceOpenParam = hasParam('pr');

    const failConditions = [isRegistered, isOpen, isApp, isLoggedIn, !hasForceOpenParam, keepForcedClose];

    const skipRender = failConditions.find(condition => Boolean(condition));
    const isDismissible = !hasParam('pr');

    useEffect(() => {
        if (!skipRender) {
            handleOverlayOpen({
                isLogin: false,
                isDismissible,
                isUndismissibleFromOutsideClick: !isDismissible,
                trackingLabel: '',
                redirectUrl: redirectUrl || window.location.href,
            });
        }
    }, [handleOverlayOpen, skipRender, isDismissible, redirectUrl]);

    return !skipRender;
};
